<div class="main-container centerWithFlex">

    <div class="inner-container">
        <form [formGroup]="feedsForm" class="full-height full-width">
            <!-----------------------Form Header----------------------->
            <div class="formHeaderRow">
                      <div class="formRow-20">

                      </div> 
                      <div class="formRow-20">

                      </div>  
                      <div class="formRow-20 bothCenter" style="font-size: x-large;font-weight:700 ;">
                        News
                      </div>
                      <div class="formRow-20">

                      </div>
                      <div class="formRow-20 bothCenter">
                          <button style="font-size: 14px;margin-right: 10px;" class="btn btn-outline-secondary rounded-pill button-align" (click)="cancelFeed()">Cancel</button>
                          <button style="font-size: 14px;" class="btn btn-outline-secondary rounded-pill button-align" (click)="saveFeed()">Submit</button>
                      </div>
            </div>

            <!-----------------------Form Body----------------------->
            <div class="formRow">
                    <div class="formRow-10">

                    </div>
                    <div class="formRow-17 verticalCenter">
                          Catergory
                        <span class="mandatoryAsterisk">&nbsp; *</span>

                    </div>
                    <div class="formRow-17 block-center">
                        <div class="formRow-85 verticalCenter">
                            <select [(ngModel)]="selectedCategory" [tabIndex]="1" class="form-control pointer-cursor full-height" 
                                    (ngModelChange)="selectCategory($event)" formControlName="categorytype">
                                <option value='' disabled selected class="font-align-poppins">Select</option>
                                <option *ngFor="let cat of categoryTypes" class="font-align-poppins" value={{cat.name}}>
                                    {{cat.name}}</option>
                            </select>
                        </div>
                        <div *ngIf="categorytype.hasError('required')" class="error-field" id="cat-error-div">
                            Category is required
                        </div>
                        <div *ngIf="!categorytype.hasError('required')" id="cat-error-div" class="error-field hidden-field">
                            no-error
                        </div>
                    </div>
                    <div class="formRow-10">

                    </div>
                    <div class="formRow-17 verticalCenter">
                        Domain
                        <span class="mandatoryAsterisk">&nbsp; *</span>
                    </div>
                    <div class="formRow-17 block-center">
                        <div class="formRow-85 verticalCenter">
                            <select [(ngModel)]="selectedDomain" [tabIndex]="2" class="form-control pointer-cursor full-height" 
                                    (ngModelChange)="selectDomain($event)" formControlName="domain">
                                <option value='' disabled selected class="font-align-poppins">Select</option>
                                <option *ngFor="let dmain of domainTypes" class="font-align-poppins" value={{dmain.name}}>
                                    {{dmain.name}}</option>
                            </select>
                        </div>
                        <div *ngIf="domain.hasError('required')" class="error-field" id="dm-error-div">
                            Domain is required
                        </div>
                        <div *ngIf="!domain.hasError('required')" id="dm-error-div" class="error-field hidden-field">
                            no-error
                        </div>
                    </div>
                    <div class="formRow-10">

                    </div>
            </div>

            <div class="formRow">
                <div class="formRow-10">

                </div>

                <div class="formRow-17 verticalCenter">
                    Description
                    <span class="mandatoryAsterisk">&nbsp; *</span>

                </div>
                <div class="formRow-17 block-center">
                    <div class="formRow-85 auto-height">

                        <input type="text" id="field-desc" name="field-desc" [tabIndex]="5" class="form-control full-height" [(ngModel)]="description" 
                        formControlName="descriptionval" (keydown.enter)="handleKeyEnter($event)">

                    </div>
                    <div *ngIf="descriptionval.hasError('required')" class="error-field" id="des-error-div">
                        Description is required
                    </div>
                    <div *ngIf="!descriptionval.hasError('required')" id="des-error-div" class="error-field hidden-field">
                        no-error
                    </div>
                </div>


                <div class="formRow-10">

                </div>
                <div class="formRow-17 verticalCenter">
                    Link

                </div>
                <div class="formRow-17 block-center">
                    <div class="formRow-85 verticalCenter">
                        <input type="text" id="feed-lnk" name="feed-lnk" [tabIndex]="4" class="form-control full-height" [(ngModel)]="feedLink" 
                            formControlName="feedlink" (keydown.enter)="handleKeyEnter($event)">
                    </div>
                    <div *ngIf="feedlink.hasError('required')" class="error-field" id="dm-error-div">
                        Link is required
                    </div>
                    <div *ngIf="!feedlink.hasError('required')" id="dm-error-div" class="error-field hidden-field">
                        no-error
                    </div>
                </div>
                <div class="formRow-10">

                </div>
            </div>

            <div class="formRow">
                <div class="formRow-10">

                </div>


                <div class="formRow-17 verticalCenter">
                    Tags
              </div>
              <div class="formRow-17 block-center">
                  <div class="formRow-85 auto-height">
                      <mat-form-field style="min-width: 100%;">
                          <mat-chip-list #chipList>
                              <mat-chip *ngFor="let sTag of selectedTags" [selectable]="selectable" [removable]="removable" (removed)="remove(sTag)">
                                  {{sTag.name}}
                                  <i class="fa fa-times-circle float-right" matChipRemove></i>
                              </mat-chip>
                              <input [tabIndex]="3" #searchInput (keyup)="searchTag($event, searchInput)" [matAutocomplete]="auto"
                              [matChipInputFor]="chipList" class="full-height">
                          </mat-chip-list>
                          <mat-autocomplete #auto="matAutocomplete">
                              <mat-option *ngFor="let dmain of tagList" (onSelectionChange)="tagSelected($event, dmain, searchInput)" [value]="dmain.name">
                                  {{dmain.name}}
                              </mat-option>
                          </mat-autocomplete>
                      </mat-form-field>
                  </div>
                  <div id="tag-error-div" class="error-field hidden-field">
                      no-error
                  </div>
              </div>


                <div class="formRow-10">

                </div>
                <div class="formRow-17 verticalCenter">
                    Content Detail

                </div>
                <div class="formRow-17 block-center">
                    <div class="formRow-85 auto-height">
                        <textarea id="cont-desc" name="cont-desc" [tabIndex]="5" class="form-control full-height textAreaMinHeight" [(ngModel)]="contentDetails" formControlName="contentDetailsval" 
                            (keydown.enter)="handleKeyEnter($event)">
                        </textarea>
                    </div>
                    <div *ngIf="contentDetailsval.hasError('required')" class="error-field" id="des-error-div">
                        Content Detail is required
                    </div>
                    <div *ngIf="!contentDetailsval.hasError('required')" id="des-error-div" class="error-field hidden-field">
                        no-error
                    </div>
                </div>
                <div class="formRow-10">

                </div>
            </div>

            <!-- <div class="formRow">
                <div class="formRow-10">

                </div>
                <div class="formRow-17 verticalCenter">
                      Tags
                </div>
                <div class="formRow-17 block-center">
                    <div class="formRow-85 verticalCenter">
                        <mat-form-field style="min-width: 100%;">
                            <mat-chip-list #chipList>
                                <mat-chip *ngFor="let sTag of selectedTags" [selectable]="selectable" [removable]="removable" (removed)="remove(sTag)">
                                    {{sTag.name}}
                                    <i class="fa fa-times-circle float-right" matChipRemove></i>
                                </mat-chip>
                                <input [tabIndex]="2" #searchInput (keyup)="searchTag($event, searchInput)" [matAutocomplete]="auto"
                                [matChipInputFor]="chipList" class="full-height">
                            </mat-chip-list>
                            <mat-autocomplete #auto="matAutocomplete">
                                <mat-option *ngFor="let dmain of tagList" (onSelectionChange)="tagSelected($event, dmain, searchInput)" [value]="dmain.name">
                                    {{dmain.name}}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>
                    <div class="error-field hidden-field" id="tg-error-div">
                        No error
                    </div>
                </div>
                <div class="formRow-10">

                </div>
                <div class="formRow-17 verticalCenter">
                     Links
                </div>
                <div class="formRow-17 block-center">
                    <div class="formRow-85 verticalCenter">
                        <input type="text" id="feed-lnk" name="feed-lnk" [tabIndex]="4" class="form-control full-height" [(ngModel)]="link">
                    </div>
                    <div class="error-field hidden-field" id="lnk-error-div">
                        No error
                    </div>
                </div>
                <div class="formRow-10">

                </div>
            </div>

            <div class="formRow">
                <div class="formRow-10">

                </div>
                <div class="formRow-17 verticalCenter">
                      Min & Max Yrs of Exp
                </div>
                <div class="formRow-17 block-center">
                    <div class="formRow-85 verticalCenter">
                        <input type="text" id="yr-exp" name="yr-exp" [tabIndex]="4" class="form-control full-height" [(ngModel)]="yrsOfExp">
                    </div>
                    <div class="error-field hidden-field" id="ye-error-div">
                        No error
                    </div>
                </div>
                <div class="formRow-10">

                </div>
                <div class="formRow-17 verticalCenter">
                     Reference Email ID
                </div>
                <div class="formRow-17 block-center">
                    <div class="formRow-85 verticalCenter">
                        <input type="text" id="ref-eml" name="ref-eml" [tabIndex]="4" class="form-control full-height" [(ngModel)]="refEmail">
                    </div>
                    <div class="error-field hidden-field" id="r-em-error-div">
                        No error
                    </div>
                </div>
                <div class="formRow-10">

                </div>
            </div>

            <div class="formRow">
                <div class="formRow-10">

                </div>
                <div class="formRow-17 verticalCenter">
                      Top 3 skills required for this job
                </div>
                <div class="formRow-17 block-center">
                    <div class="formRow-85 verticalCenter">
                        <input type="text" id="job-skl" name="job-skl" [tabIndex]="4" class="form-control full-height" [(ngModel)]="skills">
                    </div>
                    <div class="error-field hidden-field" id="sk-error-div">
                        No error
                    </div>
                </div>
                <div class="formRow-10">

                </div>
                <div class="formRow-17 verticalCenter">
                     URL to apply
                </div>
                <div class="formRow-17 block-center">
                    <div class="formRow-85 verticalCenter">
                        <input type="text" id="job-ap-url" name="job-ap-url" [tabIndex]="4" class="form-control full-height" [(ngModel)]="applyUrl">
                    </div>
                    <div class="error-field hidden-field" id="ap-error-div">
                        No error
                    </div>
                </div>
                <div class="formRow-10">

                </div>
            </div>

            <div class="formRow">
                <div class="formRow-10">

                </div>
                <div class="formRow-17 verticalCenter">
                      Publisher want user to contact him
                </div>
                <div class="formRow-17 verticalCenter">
                    <div class="formRow-30 verticalCenter">
                        <input type="radio" [checked]="isContact == true" (click)="setContact(true)">
                        <span>Yes</span>
                    </div>
                    <div class="formRow-30 verticalCenter">
                        <input type="radio" [checked]="isContact == false" (click)="setContact(false)">
                        <span>No</span>
                    </div>
                </div>
                <div class="formRow-10">

                </div>
                <div class="formRow-17 verticalCenter">
                     Job descriptions
                </div>
                <div class="formRow-17 block-center">
                    <div class="formRow-85 verticalCenter">
                        <textarea  id="job-de-de" name="job-de-de" [tabIndex]="4"
                         class="form-control full-height" [(ngModel)]="jobDescription">
                        </textarea>
                    </div>
                    <div class="error-field hidden-field" id="jd-error-div">
                        No error
                    </div>
                </div>
                <div class="formRow-10">

                </div>
            </div>

            <div class="formRow">
                <div class="formRow-10">

                </div>
                <div class="formRow-17 verticalCenter">
                    Description
                </div>
                <div class="formRow-17 block-center">
                    <div class="formRow-85 verticalCenter">
                        <input type="text" id="te-desc" name="te-desc" [tabIndex]="4" class="form-control full-height" (keyup)="validateDesc($event)" [(ngModel)]="description">
                    </div>
                    <div class="error-field" id="des-error-div" [ngClass]="{'hidden-field': validDesc}">
                        Description is required
                    </div>
                </div>
                <div class="formRow-10">

                </div>
            </div> -->
    
        </form>
    </div>

</div>